/**
 * Web stand-in for `lottie-react-native`.
 *
 * lottie-react-native ships a web build, but it renders through
 * `@lottiefiles/dotlottie-react`, which is not a dependency of this project.
 * Rather than pull in a new runtime dependency just for loading spinners, the
 * web bundle renders an ActivityIndicator at the same size and in the same
 * place as the Lottie animation.
 *
 * ZenBasket POS only uses Lottie for loaders (zen-core-elements <ZenLoader />),
 * so the behaviour - "something is loading" - is preserved.
 *
 * To render the real animations on web instead, install
 * `@lottiefiles/dotlottie-react` and delete the `lottie-react-native` entry
 * from resolve.alias in webpack.config.js.
 */

import React, {forwardRef, useImperativeHandle} from 'react';
import {ActivityIndicator, StyleSheet, View} from 'react-native';

export type AnimatedLottieViewProps = {
  source?: any;
  autoPlay?: boolean;
  loop?: boolean;
  speed?: number;
  progress?: number;
  style?: any;
  resizeMode?: 'cover' | 'contain' | 'center';
  colorFilters?: any[];
  onAnimationFinish?: () => void;
  [key: string]: any;
};

const LottieView = forwardRef<any, AnimatedLottieViewProps>(function LottieView(props, ref) {
  const {style} = props;

  useImperativeHandle(ref, () => ({
    play: () => {},
    pause: () => {},
    resume: () => {},
    reset: () => {},
  }));

  return (
    <View style={[styles.container, style]} pointerEvents="none">
      <ActivityIndicator size="large" />
    </View>
  );
});

const styles = StyleSheet.create({
  container: {alignItems: 'center', justifyContent: 'center'},
});

export {LottieView};
export default LottieView;
